import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthorization } from "../../../hooks/useAuthorization";
import { useAccount, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { RetrieveConflictedInteractions } from "../../../services/interaction-conflict-dashboard.service";
import { tokenRequest } from "../../../auth/authConfig";
import { Grid } from '@mui/material';
import DataTable from '../../../components/DataTable';
import Backdrop from '../../../components/elements/Loader';
import StyledButton from '../../../components/elements/StyledButton';
import * as Constants from "../../../helper/constants";
import {format} from 'date-fns';
import { IoWarning } from "react-icons/io5";
import { useNavigationParameters } from "../../../hooks/useNavigationParameters";

function TopConflictedInteractions(props) {

    const [canCreate, canRead, canUpdate, canDelete] = useAuthorization();
    const [appendExistingNavigationParameters,  removeDuplicatedNavigationParameters , prepareNavigationParameters] = useNavigationParameters();
    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [gridColumns, setGridColumns] = useState([]);
    const [gridRows, setGridRows] = useState([]);
    const [showViewAll, setShowViewAll] = useState(false);
    const crmConflictResolutionPage = Constants.INERACTIONCONFLICTRESOLUTIONPAGEURL + "?page=topinteractionconflicts";
    const navigate = useNavigate();
    const [isDataReady, setIsDataReady] = useState(false);

    // #region PageLoad
    useEffect(() => {
        LoadInitialData();
    }, [instance]);

    function LoadInitialData() {
        if (account) {
            instance.acquireTokenSilent(
                tokenRequest
            ).then((response) => {
                if (response) {
                    setInitialGridData(response.accessToken);
                }
            });
        }
    }

    const setInitialGridData = async (token) => {

        await RetrieveConflictedInteractions(token, 0, 0).then((rowData) => {
            setInitialGridColumns();
            if (rowData) {
                setGridRows(rowData);
                setShowViewAll(false);
            }
        }).then(() => {setIsDataReady(true)});
    }

    const setInitialGridColumns = () => {

        const columns = [];

        const columnHeaders = [{ headerName: 'Interaction ID', width: 90, field: 'id', editable: false },
        { headerName: 'Docket number', width: 250, field: 'docketNumber', editable: false },
        { headerName: 'Court location', width: 250, field: 'courtLocation', editable: false },
        { headerName: 'Upcoming court date',type: 'date', width: 150, field: 'upcomingCourtDate', renderDate: true, editable: false, renderWarning: true},
        { headerName: 'Court room', width: 180, field: 'courtRoom', editable: false },
        { headerName: 'Assigned To', width: 180, field: 'assignedTo', editable: false },
        { headerName: 'Outcome Status', width: 180, field: 'outcomeStatus', editable: false },
        { headerName: 'Review Interaction', width: 180, field: 'button', renderButton: true, editable: false }];

        columnHeaders.forEach((columnHeader) => {
           
            columns.push(
                {
                    field: columnHeader.field,
                    renderHeader: () => (<div style={{ font: 'normal normal normal 15px/16px Franklin Gothic Medium', color: "#000000" }}>{columnHeader.headerName}</div>),
                    renderCell: (params) => ( columnHeader.renderButton ? <StyledButton variant={"outlined"} color="error" onClick={(event) => {
                        navigate(`${prepareNavigationParameters(Constants.RESOLVEINTERACTIONCONFLICT, new Array(params.row.id.split("-")[1]), null)}&page=${Constants.TOPINTREVIEWDASHBOARD}`);}}>Review</StyledButton> : 
                        (columnHeader.renderWarning ? (params.row.isOutdated == '1') ? <> {params.value != null ? format(new Date(params.value), 'dd-MMM-yyyy') : null} {params.value != null && <IoWarning title="Outdated Record" size={18} style={{ color: "#d32f2f", marginLeft: "5px" }} /> } </> : <>{params.value != null ? format(new Date(params.value), 'dd-MMM-yyyy') : null}  </> :
                        (columnHeader.renderDate ? <>{params.value != null ? format(new Date(params.value), 'dd-MMM-yyyy') : null}  </>: null ))),
                    width: columnHeader.width,
                    editable: columnHeader.editable,
                },
            );
        });

        setGridColumns(columns);

    }

    //#endregion  


    if (canRead("interaction-conflict-dashboard", null)) { //ToDo - Change this role
        if (isDataReady) {
            return (<>
                <DataTable columns={gridColumns} rows={gridRows} totalCount={props.totalCount} />
                {showViewAll && <div align="center" style={{ marginTop: "10px" }}><StyledButton variant={"outlined"} color="error" onClick={() => navigate(`${prepareNavigationParameters(Constants.INTREVIEWDASHBOARD, null, null)}`)} >View All</StyledButton></div>}
            </>
            );
        } else {
            return (
                <Backdrop />
            );
        }
    } else {
        return (
            <Grid container style={{ padding: "10px 20px 20px 20px", border: "1px solid #7F8284", margin: "10px 0px 10px 0px", borderRadius: "8px" }}>
                <Grid item xs={12} md={12} style={{
                    textAlign: "left", font: "normal normal normal 17px/22px Franklin Gothic Medium",
                    letterSpacing: "0px", color: " #000000", opacity: "1", marginBottom: "15px"
                }}>Interaction Review Dashboard
                </Grid>
                <Grid item xs={12} md={12} style={{
                    textAlign: "left", font: "normal normal 200 15px/17px Franklin Gothic Medium",
                    letterSpacing: "0px", color: " #000000", opacity: "1",
                }}>** You are not authorized to view these details **
                </Grid>
            </Grid>
        );
    }
}

export default TopConflictedInteractions;